<template>
<div>
	<h1>Get in touch</h1>
    <section class="section pb-0 section-components">

        <div class="container mb-5">
            <!-- Inputs -->
					<div class="row">
						<div class="col-12">
            <h3 class="h4 text-success font-weight-bold mb-4">Send a message</h3>
						</div>
					</div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input label="Name" @keyup="validateName" :valid="valid.name" :error="error.name" ref="name" required v-model="contact.name"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input label="Email address" ref="email" @keyup="validateEmail"  :valid="valid.email" :error="error.email" required v-model="contact.email"></base-input>
                </div>
            </div>
							<div class="row">
                <div class="my-3 col-12">
                    <label class="">Message</label>
                </div>
									<div class="col-12">
										<textarea class="form-control"  rows="10"  v-model="contact.message"></textarea>

									</div>
							</div>
				
					<a href="#"  id="submit-button" class="btn btn-primary" @click.prevent="submitMessage">Send</a>
					<base-alert type="danger" v-if="error.submit">
							<strong>You haven't filled all required fields</strong> Please fill all the fields and try again
					</base-alert>

        </div>
        <div class="py-5 container">
					<h3 class="h4 text-success font-weight-bold mb-4">Call us</h3>
                <!-- Inputs (alternative) -->
                <div class="mb-3">
                </div>
                <div class="row">
                    <div class="col-12">
											<h3>Customer Service centre</h3>
											<h1>0843 289 2889</h1>
											<h5 class="mt-5">You can reach us from:</h5>
											<h5><span class="font-weight-bold">9am to 5pm </span><small class="mutted"> Mondays to Fridays</small></h5>
<div class="mt-4">If you are outside the UK, please call +44 843 289 2889</div>
<small>Calls may be monitored or recorded for training purposes.</small>
                    </div>
                </div>
        </div>
				 <div class="py-5 container">
					<h3 class="h4 text-success font-weight-bold mb-4">
						Write to us
				</h3>
                <!-- Inputs (alternative) -->
                <div class="mb-3">
                </div>
                <div class="row">
                    <div class="col-12">
											<h4>Correspondence address:</h4>
											<div>94B Regent Street</div>
											<div>Cambridge</div>
											<div>CB2 1DP</div>
											<div>United Kingdom</div>
                    </div>
                </div>
        </div>

    </section>

</div>
</template>

<script>
export default {
	mounted: function() {
		this.loadToParent();	
	},
	data() {
		return {
			metadata: {
				section: "Contacts",
				title: "Get in touch"
			},
			contact: {
				name: "",
				email: "",
				message: "",
			},
			valid: {
				name: null,
				email: null,
			},
			error: {
				name: null,
				email: null,
				submit: false,
			},
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		},
		validateName: function() {
			var valid = true
			if( this.contact.name.trim() ==="") {
				this.valid.name = false;
				this.error.name = "You must enter your name"
				valid = false;
			} else {
				this.valid.name = true;
				this.error.name = ""
				valid = true;
			}					
			return valid;
		},
		validateEmail: function() {
			var valid = true
			if( this.contact.email.trim() ==="") {
				this.valid.email = false;
				this.error.email = "You must enter your email"
				valid = false;
			} else {
				this.valid.email = true;
				this.error.email = ""
				valid = true;
			}					
			return valid;
		},
		checkAllValidations: function () {
			var validkeys = Object.keys(this.valid);
			for (var i = 0 ; i < validkeys.length; i++) {
				if (!this.valid[validkeys[i]] || this.valid[validkeys[i]] == null) {
					this.error.submit = true;
					return false;	
				}
			}
			this.error.submit=false;
			return true;
		},
		submitMessage: function() {
			var valid = this.checkAllValidations()
			if (valid) {
				this.$router.push({ 
					name: "thank_you_for_contacting",
					params: { messageType: "contact_message", message: this.contact},
				});
			}
		},
	},
}
</script>
<style>
	.has-danger::after,
	.has-success::after {
		top:37px !important;
	}
</style>
